import {
  del,
  del2,
  del3,
  externalGet,
  get,
  patch,
  post,
  postFeedback,
  postMultiPart,
  put,
  put2,
} from "./api_helper";
import * as urls from "./url_helper";
// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

const patchRequest = (url) => patch(url);

const getRequest = (url) => get(url);
// Register Method
const postFakeRegister = (data) => post(urls.POST_FAKE_REGISTER, data);

// Login Method
const postFakeLogin = (data) => post(urls.POST_FAKE_LOGIN, data);

// postForgetPwd
const postFakeForgetPwd = (data) => post(urls.POST_FAKE_PASSWORD_FORGET, data);

// postSetNewPwd
const postSetNewPwd = (url, data) => post(url, data);

// postResetPwd
const postResetPassword = (url, data) => post(url, data);

//detailSet for new USer
const postDetailSet = (url, data) => post(url, data);
//verify email
const verifyNewMail = (url, data) => post(url, data);
//get candidate list
const candidateList = (url, data) => post(url, data);
//get candidates count
const candidateCount = (url) => get(url);
//get resume parsing
const resumeParsing = (data, filename) => post(data, filename);
//taxonomy api call
const TaxoJobProfile = (url, data) => post(url, data);
// Edit profile
const postJwtProfile = (data) => post(urls.POST_EDIT_JWT_PROFILE, data);

//Get Profile Detail
const postProfileDetail = (url) => get(url);
//Update Profile Detail
const postUpdateProfile = (url, data) => post(url, data);

//Update Password
const postUpdatePassword = (url, data) => post(url, data);

const postFakeProfile = (data) => post(urls.POST_EDIT_PROFILE, data);

// Register Method
//call register method api
const postJwtRegister = (url, data) => post(url, data);

//social Login method api
const postSocialRegister = (url, data) => post(url, data);

// Login Method
const postJwtLogin = (url, data) => post(url, data);

// postForgetPwd
const postJwtForgetPwd = (data) =>
  post(urls.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = (url, data) => post(url, data);

// get Products
export const getProducts = () => get(urls.GET_PRODUCTS);

// get Product detail
export const getProductDetail = (id) =>
  get(`${urls.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } });

// get Events
export const getEvents = () => get(urls.GET_EVENTS);

// add Events
export const addNewEvent = (event) => post(urls.ADD_NEW_EVENT, event);

// update Event
export const updateEvent = (event) => put(urls.UPDATE_EVENT, event);

// delete Event
export const deleteEvent = (event) =>
  del(urls.DELETE_EVENT, { headers: { event } });

// get Categories
export const getCategories = () => get(urls.GET_CATEGORIES);

// get chats
export const getChats = () => get(urls.GET_CHATS);

// get groups
export const getGroups = () => get(urls.GET_GROUPS);

// get Contacts
export const getContacts = () => get(urls.GET_CONTACTS);

// get messages
export const getMessages = (roomId = "") =>
  get(`${urls.GET_MESSAGES}/${roomId}`, { params: { roomId } });

// post messages
export const addMessage = (message) => post(urls.ADD_MESSAGE, message);

// get project
export const getProjects = () => get(urls.GET_PROJECTS);

// get project details
export const getProjectsDetails = (id) =>
  get(`${urls.GET_PROJECT_DETAIL}/${id}`, { params: { id } });

// get tasks
export const getTasks = () => get(urls.GET_TASKS);

// get contacts
export const getUsers = () => get(urls.GET_USERS);

export const getUserProfile = () => get(urls.GET_USER_PROFILE);

//bulk import multipart
const postBulkimportmultipart = (url, data) => postMultiPart(url, data);

//candidate bulk import
const postBulkimport = (url, data) => post(url, data);

//get Search candidate list
const candidateSearchList = (url, data) => post(url, data);

//get search candidate count
const candidateSearchCount = (url, data) => post(url, data);

//Candidate Operation
const postAddNewCandidate = (url, data) => post(url, data);

//Candidate Delete
const deleteCandidates = (url, data) => post(url, data);

//Candidate Delete
const checkDuplicateCandidate = (url, data) => post(url, data);
//Update Candidate
const postUpdateCandidate = (url, data) => put2(url, data);
//Get Candidate Data
const postGetCandidateData = (url, data) => post(url, data);
// get countries
const getAllCounties = (url) => get(url);
// get state
const getStates = (url, data) => post(url, data);
// get ipbased location
const getIpLocation = (url) => externalGet(url);

const getStateAndCountry = (url) => get(url);
// matching job
const getMatchingJobs = (url) => get(url);
// job Details
const getJobDetail = (url, data) => post(url, data);

const getValidateUrl = (url) => get(url);

//Dashboard
const getPublishedJobList = (url) => get(url);
const getRecruitmentAnalyticsData = (url) => get(url);
const getDashboardCardsData = (url) => get(url);
const getDashboardTopCardData = (url) => get(url);
const getRecruitmentReport = (url) => get(url);
const getJobStatus = (url) => get(url);
const getUpcomingInterviews = (url) => get(url);
const getJobCompletion = (url) => get(url);
const postNewInterviewDetails = (url, data) => post(url, data);

//view Candidate
const getCandidateActiveData = (url) => get(url);

//admin dashboard
const getAdminDbTopCards = (url) => get(url);

//admin organization
const updateCompanyStatus = (url, data) => patch(url, data);
const addNewUser = (url, data) => post(url, data);

const addVideo = (url, data) => post(url, data);
const updateVideoDetails = (url, data) => put2(url, data);

//report issues
const getListData = (url) => get(url);
const updateReport = (url, data) => put2(url, data);
const postStatus = (url, data) => post(url, data);

//Aimarkup
const getAimarkupDetails = (url) => get(url);
const putAimarkupDetails = (url, data) => put2(url, data);

//get my team list
const getUsersListFB = (url) => get(url);
const updateUserDetailGet = (url) => get(url);
const updateUserDetailPost = (url, data) => post(url, data);
const addNewUserPost = (url, data) => post(url, data);
const deleteUserFB = (url) => get(url);
const getALLRolesGet = (url) => get(url);

// EmailContent
const getEmailListFB = (url) => get(url);
const UpdateEmailContentGet = (url) => get(url);
const updateEmailDetailsPost = (url, data) => post(url, data);
const addNewEmailContentPost = (url, data) => post(url, data);

//get settings list
const settingsListGet = (url) => get(url);
const updateSettingsDetailsGet = (url) => get(url);
const updateSettingsDetailsPost = (url, data) => post(url, data);
const addSettingsDetailsPost = (url, data) => post(url, data);

//interviews
const getCalendarEventsData = (url) => get(url);

//acl
const aclGetAllRoles = (url) => get(url);
const aclUpdateRole = (url, data) => post(url, data);
const aclGetAllPermissions = (url) => get(url);
const aclUpdatePermission = (url, data) => post(url, data);
const aclGetAllPermissionRoleMappings = (url) => get(url);
const aclUpdateAllPermissionRoleMappings = (url, data) => post(url, data);

//get job list
const jobList = (url, data) => post(url, data);
const jobList2 = (url) => get(url);
//get job count
const jobCount = (url) => get(url);
//get search job count
const jobSearchCount = (url, data) => post(url, data);
//get Search job list
const jobSearchList = (url, data) => post(url, data);
const jobSearchList2 = (url) => get(url);
const postGetJobData = (url) => get(url);
const postJdData = (url, data) => post(url, data);
const postUpdateJob = (url, data) => put2(url, data);

//get jobAnalysis Details

const getJobAnalysisDetails = (url) => get(url);

//Get Job Type

const getJobTypeDetails = (url) => get(url);

//Add Job
const postAddNewJob = (url, data) => post(url, data);

//add interview round
const postAddInterviewRound = (url, data) => post(url, data);

//
const postCall = (url, data) => post(url, data);

const putCall = (url, data) => put2(url, data);
//post jobDistribution
const postJobIdDistribution = (url, data) => post(url, data);

//get jobStatus
const getJobIdJobStatus = (url, data) => get(url, data);

const deleteCall = (url) => del(url);
const deleteCall2 = (url) => del3(url);

const deleteApp = (url) => del2(url);

//get
const getMangeJobLink = (url, data) => post(url, data);

//Delete Job
const deleteJobPost = (url, data) => post(url, data);

// Similar candidate
const getSimilarCandidate = (url) => get(url);
// Similar candidate
const getSimilarCandidateDetails = (url, data) => post(url, data);

// set candidate job map
const getCandidateJobMap = (url, data) => post(url, data);
// set candidate job map
const postCallForJob = (url) => get(url);
// set candidate job map
const postCallMapping = (url) => post(url);

//get qualification list
const postQualificationList = (url) => get(url);

const getCall = (url, params) => {
  if (url.includes("?")) {
    return get(url, null);
  }

  // Filter out null, undefined, 'null' string, and Redux metadata
  const cleanParams = params
    ? Object.entries(params)
        .filter(
          ([key, value]) =>
            value != null &&
            value !== "null" &&
            value !== "" &&
            key !== "type" &&
            key !== "payload",
        )
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    : null;

  return get(
    url,
    Object.keys(cleanParams || {}).length > 0 ? cleanParams : null,
  );
};

const postAddCandidate = (url, data) => post(url, data);
//Candidate method handle
const postCandidateResume = (url, data) => post(url, data);
// get candidates matching jobs
const getCandidatesMyJobs = (url) => get(url);
const getCandidatesJobDetail = (url) => get(url);
const postCandidatesMatchingJobs = (url, data) => post(url, data);
const getMatchingCandidates = (url) => get(url);

//post close job

const postCloseJob = (url, data) => get(url, data);

//post extend job

const postExtendJob = (url, data) => post(url, data);

//viewjob
const postModalPopudata = (url, data) => post(url, data);

//recuriter
//add organization
const postAddOrganization = (url, data) => post(url, data);
//get organization detail
const postGetOrganizationDetail = (url, data) => post(url, data);
//update organization detail
const postUpdateOrganizationDetail = (url, data) => post(url, data);
//get organization list
const PostOrganizationList = (url, data) => post(url, data);
//delete organization
const DELETEOrganization = (url, data) => post(url, data);
//
const getOrgDetail = (url, data) => post(url, data);
//submit feedback
const submitFeedBack = (url, data, code) => postFeedback(url, data, code);

//submit document
const submitDoumnetList = (url) => get(url);
const submitDocumentsData = (url, data) => post(url, data);

const getCandidateShortListing = (url) => get(url);

//candidate interview feedback
const getInterviewCandidateList = (url) => get(url);

//get hiring feedback status
const getHiringStatus = (url) => get(url);

//get CandidateData interviewer feedback
const getCandidateDataFeedback = (url) => get(url);

//get interviewer feedback
const getInterviewersList = (url) => get(url);

const feedbackCandidateShortList = (url) => get(url);

const CandidateInterestFeedback = (url) => get(url);

const getCareerInfo = (url) => get(url);
const editCareerInfo = (url, data) => post(url, data);

const getInterviewersInfo = (url) => get(url);
const postScheduleInterview = (url, data) => post(url, data);
const addInterviewerPost = (url, data) => post(url, data);
const postRescheduleInterview = (url, data) => post(url, data);
const postAboutOnInterview = (url, data) => post(url, data);

const candidateInterviewDetails = (url) => get(url);
const postCandidateStageDetails = (url, data) => post(url, data);
const postCurrentCandidateStageDetails = (url, data) => post(url, data);
const postCandidateFeedback = (url, data) => post(url, data);
const getCommentsCandidateList = (url) => get(url);
const postCommentCandidate = (url, data) => post(url, data);

const getInterviews = (url) => get(url);
const getCandidateScreeningData = (url) => get(url);

const postUpdateScreenedCandidateDetails = (url, data) => post(url, data);

const getShortListManagerList = (url) => get(url);

const postAddShortlistManager = (url, data) => post(url, data);

const postMoveToshortlist = (url, data) => post(url, data);

const getShortlistCandidateData = (url) => get(url);

const postUpdateShortlistCandidateDetails = (url, data) => post(url, data);

const getCountryAndState = (url) => get(url);

const getOrganizationNotifications = (url) => get(url);
const updateOrganizationNotifications = (url, data) => post(url, data);
const getUnMappedJobs = (url) => get(url);

//recruiter
const getActiveJobs = (url) => get(url);
const getClosedJobs = (url) => get(url);
const standardGet = (url) => get(url);
const standardPost = (url, data) => post(url, data);

//manage assessment
const getassesment = (url, data) => get(url);
const updateAssessmentStatus = (url, data) => patch(url, data);
const postAssesmentQuestions = (url, data) => post(url, data);
const updateAssessmentQuestions = (url, data) => put2(url, data);

//cancel interview
const cancelOfferletter = (url, data) => post(url, data);

// Matching Weightage
const getDefaultWeightage = (url) => get(url);
const getCustomWeightage = (url) => get(url);
const postCustomWeightage = (url, data) => post(url, data);

export {
  getMatchingCandidates,
  CandidateInterestFeedback,
  DELETEOrganization,
  PostOrganizationList,
  TaxoJobProfile,
  UpdateEmailContentGet,
  aclGetAllPermissionRoleMappings,
  aclGetAllPermissions,
  aclGetAllRoles,
  aclUpdateAllPermissionRoleMappings,
  aclUpdatePermission,
  aclUpdateRole,
  addInterviewerPost,
  addNewEmailContentPost,
  addNewUser,
  addNewUserPost,
  addSettingsDetailsPost,
  addVideo,
  cancelOfferletter,
  candidateCount,
  candidateInterviewDetails,
  candidateList,
  candidateSearchCount,
  candidateSearchList,
  checkDuplicateCandidate,
  deleteApp,
  deleteCall,
  deleteCall2,
  deleteCandidates,
  deleteJobPost,
  deleteUserFB,
  editCareerInfo,
  externalGet,
  feedbackCandidateShortList,
  getALLRolesGet,
  getActiveJobs,
  getAdminDbTopCards,
  getAimarkupDetails,
  getAllCounties,
  getCalendarEventsData,
  getCall,
  getCandidateActiveData,
  getCandidateDataFeedback,
  getCandidateJobMap,
  getCandidateScreeningData,
  getCandidateShortListing,
  getCandidatesJobDetail,
  getCandidatesMyJobs,
  getCareerInfo,
  getClosedJobs,
  getCommentsCandidateList,
  getCountryAndState,
  getDashboardCardsData,
  getDashboardTopCardData,
  getEmailListFB,
  getHiringStatus,
  getInterviewCandidateList,
  getInterviewersInfo,
  getInterviewersList,
  getInterviews,
  getIpLocation,
  getJobAnalysisDetails,
  getJobCompletion,
  getJobDetail,
  getJobIdJobStatus,
  getJobStatus,
  getJobTypeDetails,
  getListData,
  getLoggedInUser,
  getMangeJobLink,
  getMatchingJobs,
  getOrgDetail,
  getOrganizationNotifications,
  getPublishedJobList,
  getRecruitmentAnalyticsData,
  getRecruitmentReport,
  getRequest,
  getShortListManagerList,
  getShortlistCandidateData,
  getSimilarCandidate,
  getSimilarCandidateDetails,
  getStateAndCountry,
  getStates,
  getUnMappedJobs,
  getUpcomingInterviews,
  getUsersListFB,
  getValidateUrl,
  getassesment,
  isUserAuthenticated,
  jobCount,
  jobList,
  jobList2,
  jobSearchCount,
  jobSearchList,
  jobSearchList2,
  patchRequest,
  postAboutOnInterview,
  postAddCandidate,
  postAddInterviewRound,
  postAddNewCandidate,
  postAddNewJob,
  postAddOrganization,
  postAddShortlistManager,
  postAssesmentQuestions,
  postBulkimport,
  postBulkimportmultipart,
  postCall,
  postCallForJob,
  postCallMapping,
  postCandidateFeedback,
  postCandidateResume,
  postCandidateStageDetails,
  postCandidatesMatchingJobs,
  postCloseJob,
  postCommentCandidate,
  postCurrentCandidateStageDetails,
  postDetailSet,
  postExtendJob,
  postFakeForgetPwd,
  postFakeLogin,
  postFakeProfile,
  postFakeRegister,
  postGetCandidateData,
  postGetJobData,
  postGetOrganizationDetail,
  postJdData,
  postJobIdDistribution,
  postJwtForgetPwd,
  postJwtLogin,
  postJwtProfile,
  postJwtRegister,
  postModalPopudata,
  postMoveToshortlist,
  postNewInterviewDetails,
  postProfileDetail,
  postQualificationList,
  postRescheduleInterview,
  postResetPassword,
  postScheduleInterview,
  postSetNewPwd,
  postSocialRegister,
  postStatus,
  postUpdateCandidate,
  postUpdateJob,
  postUpdateOrganizationDetail,
  postUpdatePassword,
  postUpdateProfile,
  postUpdateScreenedCandidateDetails,
  postUpdateShortlistCandidateDetails,
  putAimarkupDetails,
  putCall,
  resumeParsing,
  settingsListGet,
  standardGet,
  standardPost,
  submitDocumentsData,
  submitDoumnetList,
  submitFeedBack,
  updateAssessmentQuestions,
  updateAssessmentStatus,
  updateCompanyStatus,
  updateEmailDetailsPost,
  updateOrganizationNotifications,
  updateReport,
  updateSettingsDetailsGet,
  updateSettingsDetailsPost,
  updateUserDetailGet,
  updateUserDetailPost,
  updateVideoDetails,
  verifyNewMail,
  getDefaultWeightage,
  getCustomWeightage,
  postCustomWeightage,
};
